var React = require('react');

function Location (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.7143 10.2857C19.7143 16.2857 12.0001 21.4286 12.0001 21.4286C12.0001 21.4286 4.28577 16.2857 4.28577 10.2857C4.28577 8.23974 5.09852 6.27758 6.54523 4.83087C7.99194 3.38416 9.9541 2.57141 12.0001 2.57141C14.046 2.57141 16.0082 3.38416 17.4549 4.83087C18.9016 6.27758 19.7143 8.23974 19.7143 10.2857Z","stroke":"#5B59FB","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12 12.8571C13.4202 12.8571 14.5714 11.7058 14.5714 10.2857C14.5714 8.8655 13.4202 7.71423 12 7.71423C10.5799 7.71423 9.42859 8.8655 9.42859 10.2857C9.42859 11.7058 10.5799 12.8571 12 12.8571Z","stroke":"#5B59FB","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Location.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Location;

Location.default = Location;
